"use client";
import React, { useEffect, useState } from "react";

// import { Layout } from "antd";

// const { Header, Footer, Content } = Layout;

// import Image from "next/image";
// import Header from "@/components/molecules/Headers/HeaderCreateAccount";
// import FooterSignIn from "@/components/molecules/FooterSignIn";
// import { useTimerStore } from "@/store/use-timer-store";
// import { useUser } from "@auth0/nextjs-auth0/client";
// import { userSignUp } from "@/services/userService";
// import { useRouter } from "next/navigation";
// import { useFetchUserProfile } from "@/hooks/use-user-profile"; // adjust path if needed
import welcomeLogo from "../../assets/images/welcome.svg";
import clock from "../../assets/images/clock.svg";
import OnboardingLayout from "../../layouts/Onboarding";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function Index() {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  const close = () => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <OnboardingLayout close={close}>
      <div className="flex flex-col relative bg-white">
        {/* Header */}
        {/* <Header
                    title="Create an account"
                    onBack={() => {}}
                    onClose={() => {}}
                /> */}

        {/* Main content container */}

        <main
          className="flex flex-1 flex-col items-center justify-center text-center px-6"
          style={{ marginTop: "64px" }}
        >
          <div className="max-w-xs w-full flex flex-col items-center">
            {/* <Image
                        src="/assets/images/welcome.svg"
                        alt="Welcome Icon"
                        width={120}
                        height={120}
                        className="mb-6"
                        priority
                    /> */}
            <img src={welcomeLogo} alt="Logo" width="200" />
            <h2 className="text-2xl font-bold text-brand-primary">Hello!</h2>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">
              Experience the future of investing at 80Eight.
              <br />
              Your journey starts here.
            </p>

            {/* Timer pill */}
            <div className="flex items-center justify-center mb-8">
              <div
                className="px-3 py-1 bg-bg-light-purple 
                                        rounded-full flex items-center justify-center"
              >
                <div className="flex items-center space-x-1 text-xs font-medium text-brand-secondary">
                  <img src={clock} alt="clock" className="w-4 h-4" />
                  <span>5 mins</span>
                </div>
              </div>
            </div>

            {/* {userProfile && userProfile.profile_completed && (
                        <p className="mb-4 text-sm text-green-600">{autoRedirectMessage}</p>
                    )} */}

            {/* Let’s go button */}
            <button
              className="btn-primary mt-6 h-14 w-96 rounded-full font-semibold text-white transition-transform duration-200 shadow-lg"
              onClick={() => {
                navigate("/onboarding/signup");
              }}
              // onClick={handleSignUp}
              // disabled={
              // loading ||
              // authLoading ||
              // profileLoading ||
              // (userProfile && userProfile.profile_completed)
              // }
            >
              Lets go
            </button>
          </div>
        </main>

        {/* Footer */}
        {/* <FooterSignIn /> */}
      </div>
    </OnboardingLayout>
  );
}
